import { set, get } from '../global/lib/lodash';

export function toRaw(cols) {
    let obj = { id: this.id };
            
    cols.map(m => {
        const name = m.rawName || m.name;
        set(obj, name, get(this, name, get(this, `_raw.${name}`)))
    })

    return obj;
}